const AnomalyDetectedIcon = () => {
  return (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="25" height="25" rx="12.5" fill="#54B4B5" />
      <rect x="0.5" y="0.5" width="25" height="25" rx="12.5" stroke="#D4ECED" />
      <path
        d="M16.8564 16.8594L19.6635 19.6664"
        stroke="white"
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M6.77246 10.1927C7.68694 7.93061 9.90792 6.33301 12.4967 6.33301C15.9072 6.33301 18.6651 9.10494 18.6651 12.5014C18.6651 15.8979 15.9142 18.6628 12.4967 18.6628C10.0832 18.6628 7.98759 17.2713 6.97518 15.2478"
        stroke="white"
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M6.33008 12.5715H8.65289C9.10201 12.5715 9.51604 12.3049 9.73359 11.8838L10.3652 10.6908C10.5967 10.2487 11.2003 10.34 11.3125 10.8382L12.2108 14.754C12.3231 15.2522 12.9476 15.3435 13.1652 14.8803L14.2038 12.7119"
        stroke="white"
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M14.5839 12.8025C15.0611 12.8025 15.447 12.4165 15.447 11.9393C15.447 11.4621 15.0611 11.0762 14.5839 11.0762C14.1067 11.0762 13.7207 11.4621 13.7207 11.9393C13.7207 12.4165 14.1067 12.8025 14.5839 12.8025Z"
        stroke="white"
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export default AnomalyDetectedIcon;
